document.addEventListener('DOMContentLoaded', function () {
  // Check if the current page is a collection page
  if (window.location.pathname.includes('/collections/')) {
    const nextLink = document.querySelector('link[rel="next"]');
    if (nextLink) {
      nextLink.remove();
    }
  }
});

